import { povileThemeColors, directaThemeColors, limePayThemeColors, oneKeyThemeColors, tupayTheme, gatewayDepositThemeColors } from './themes';
import { PanelType } from '../utils/Constants';
import { zimoThemeColors } from './themes/zimo';

const urls = {
  logo: 'https://resources.directa24.com/misc/logo',
};

export const panelConfigs = {
  POVILE: {
    REACT_APP_LOGO_URL: {
      defaultLogo: `${urls.logo}/povile/povile-logo.png`,
      defaultLogoLogin: `${urls.logo}/povile/povile-logo.png`,
      defaultLogoSignup: `${urls.logo}/povile/povile-logo.png`,
      square: `${urls.logo}/povile/povile-logo.png`,
      background: `${urls.logo}/povile/povile-background.png`,
      title: 'Povile',
    },
    REACT_APP_FAVICON: `${urls.logo}/povile/favicon.ico`,
    REACT_APP_THEME: povileThemeColors,
    REACT_APP_DOCUMENTATION_URL: 'https://docs.directa24.com',
    REACT_APP_PANEL_TYPE: PanelType.POVILE,
    REACT_APP_CONTACT_EMAIL: ' tax@povileinc.com',
  },
  DIRECTA: {
    REACT_APP_LOGO_URL: {
      defaultLogo: `${urls.logo}/directa-logo-crop-color.png`,
      defaultLogoLogin: `${urls.logo}/directa-logo-crop-color.png`,
      defaultLogoSignup: `${urls.logo}/directa-logo-crop-white.png`,
      square: `${urls.logo}/directa-logo-square.png`,
      background: `${urls.logo}/d24-background.png`,
      backgroundSignup: `${urls.logo}/d24-background.png`,
      title: 'Directa 24',
    },
    REACT_APP_FAVICON: `${urls.logo}/favicon.ico`,
    REACT_APP_THEME: directaThemeColors,
    REACT_APP_DOCUMENTATION_URL: 'https://docs.directa24.com',
    REACT_APP_PANEL_TYPE: PanelType.DIRECTA,
    REACT_APP_CONTACT_EMAIL: ' ',
  },
  LIMEPAY: {
    REACT_APP_LOGO_URL: {
      defaultLogo: `${urls.logo}/lime-pay/limepay-logo.png`,
      defaultLogoLogin: `${urls.logo}/lime-pay/limepay-logo.png`,
      defaultLogoSignup: `${urls.logo}/lime-pay/limepay-logo.png`,
      square: `${urls.logo}/lime-pay/limepay-logo.png`,
      background: `${urls.logo}/lime-pay/limepay-background.png`,
      backgroundSignup: '',
      title: 'Lime Pay',
    },
    REACT_APP_FAVICON: `${urls.logo}/lime-pay/favicon.ico`,
    REACT_APP_THEME: limePayThemeColors,
    REACT_APP_DOCUMENTATION_URL: 'https://docs.lime-pay.com',
    REACT_APP_PANEL_TYPE: PanelType.LIME_PAY,
    REACT_APP_CONTACT_EMAIL: 'tax@lime-pay.com',
  },
  ONEKEY_PAYMENTS: {
    REACT_APP_LOGO_URL: {
      defaultLogo: `${urls.logo}/onekey-payments/onekeypayments-logo-v2.png`,
      defaultLogoLogin: `${urls.logo}/onekey-payments/onekeypayments-logo-v2.png`,
      defaultLogoSignup: `${urls.logo}/onekey-payments/onekeypayments-logo-v2.png`,
      square: `${urls.logo}/onekey-payments/onekeypayments-white-green-logo.png`,
      background: `${urls.logo}/onekey-payments/onekeypayments-background.png`,
      backgroundSignup: '',
      title: 'One Key Payments',
    },
    REACT_APP_FAVICON: `${urls.logo}/onekey-payments/favicon.ico`,
    REACT_APP_THEME: oneKeyThemeColors,
    REACT_APP_DOCUMENTATION_URL: 'https://apidocs.onekeypayments.com',
    REACT_APP_PANEL_TYPE: PanelType.ONEKEY_PAYMENTS,
    REACT_APP_CONTACT_EMAIL: 'tax@lime-pay.com',
  },
  TUPAY: {
    REACT_APP_LOGO_URL: {
      defaultLogo: `${urls.logo}/directa-tupay-logo-corp-login.png`,
      defaultLogoLogin: `${urls.logo}/directa-tupay-logo-corp-login.png`,
      defaultLogoSignup: `${urls.logo}/directa-tupay-logo-corp-login.png`,
      titleSignUp: 'titleSignUpTupay',
      square: `${urls.logo}/directa-tupay-logo-corp-login.png`,
      background: `${urls.logo}/tupay/tupay-background.png`,
      title: 'Tupay',
      companyImg: 'directa-tupay-logo-corp.png',
    },
    REACT_APP_FAVICON: `${urls.logo}/tupay/favicon.ico`,
    REACT_APP_THEME: tupayTheme,
    REACT_APP_DOCUMENTATION_URL: 'https://docs.tupayonline.com',
    REACT_APP_PANEL_TYPE: PanelType.TUPAY,
    REACT_APP_CONTACT_EMAIL: 'tax@tupaypagos.com',
    DEFAULT_COUNTRY_FILTER: {
      countryCode: 'PE',
      countryName: 'Peru',
      currencyCode: 'PEN',
    },
  },
  GATEWAY_DEPOSIT: {
    REACT_APP_LOGO_URL: {
      defaultLogo: `${urls.logo}/gateway-deposit/gateway-deposit-logo-crop.png`,
      defaultLogoLogin: `${urls.logo}/gateway-deposit/gateway-deposit-logo.png`,
      defaultLogoSignup: `${urls.logo}/gateway-deposit/gateway-deposit-logo.png`,
      square: `${urls.logo}/gateway-deposit/gateway-deposit-logo.png`,
      background: `${urls.logo}/gateway-deposit/gateway-deposit-background.jpg`,
      backgroundSignup: `${urls.logo}/gateway-deposit-background.jpg`,
      title: 'Gateway Deposits',
    },
    REACT_APP_FAVICON: `${urls.logo}/gateway-deposit/favicon.ico`,
    REACT_APP_THEME: gatewayDepositThemeColors,
    REACT_APP_DOCUMENTATION_URL: 'https://docs.gateway-deposit.com',
    REACT_APP_PANEL_TYPE: PanelType.GATEWAY_DEPOSIT,
  },
  ZIMO: {
    REACT_APP_LOGO_URL: {
      defaultLogo: `${urls.logo}/zimo/loco_positivo_2-lineas.png`,
      defaultLogoLogin: `${urls.logo}/zimo/zimo-logo-1-linea.png`,
      defaultLogoSignup: `${urls.logo}/zimo/zimo-logo-1-linea.png`,
      square: `${urls.logo}/gateway-deposit/gateway-deposit-logo.png`,
      background: `${urls.logo}/zimo/zimo-bg.png`,
      backgroundSignup: `${urls.logo}/zimo/zimo-bg.png`,
      title: 'Zimo',
    },
    REACT_APP_FAVICON: `${urls.logo}/zimo/favicon.ico`,
    REACT_APP_THEME: zimoThemeColors,
    REACT_APP_DOCUMENTATION_URL: 'https://docs.zimo-pagos.com',
    REACT_APP_PANEL_TYPE: PanelType.ZIMO,
    DEFAULT_COUNTRY_FILTER: {
      countryCode: 'AR',
      countryName: 'Argentina',
      currencyCode: 'ARS',
    },
  },
};
